import EventEmitter from 'eventemitter3';
import { Account, initOptions } from '../types/types';
import ProviderUtils from './ProviderUtils';
import { BASE_URL } from '../constant';

export default class BasicProvider extends EventEmitter {
  isConnected: boolean;
  utils: ProviderUtils;
  constructor(options?: initOptions) {
    super();
    this.utils = new ProviderUtils({
      ...BASE_URL,
      ...options,
    });
    this.isConnected = false;
  }

  async connect(
    method: string,
    params?: {
      tonProof?: string;
      email?: string;
      domain?: string;
      chainId?: number;
    }
  ) {
    const [chainType, operation] = this.utils.getMethodInfo(method);
    if (this.utils._accounts && this.utils._accounts[chainType]) {
      const account = this.utils._accounts[chainType];
      this.utils._account = account;
      this.isConnected = true;
      return account;
    }
    const res: Account = await this.utils.request({
      method,
      params: params ? [params] : [],
    }) as any;
    this.isConnected = true;
    return res;
  }

  async disconnect(method: string) {
    const [chainType, operation] = this.utils.getMethodInfo(method);
    this.utils._account = null;
    this.utils.removeAccount(chainType);
    this.emit('accountsChanged', []);
    this.emit('disconnect', '');
  }
}
